<template>
  <div>
    <Head title="Stocktake" />
    <h1 class="mb-8 text-3xl font-bold">Stocktake</h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="search.search" class="mr-4 w-full max-w-md" @reset="reset">
        <label class="block text-gray-700">Status:</label>
      </search-filter>
      <Link v-if="user.role === 'admin' || user.role === 'manager'" class="btn-orange" href="/stocktake-references/create">
        <span>Create</span>
        <span class="hidden md:inline">&nbsp;Count</span>
      </Link>
    </div>
    <hr />
    <ul
      id="tabs-tabFill"
      class="nav nav-tabs flex flex-col md:flex-row flex-wrap list-none border-b-0 pl-0 mb-4"
      role="tablist"
    >
      <li class="nav-item flex-auto text-center" role="presentation">
        <a
          id="tabs-home-tabFill"
          href="#tabs-homeFill"
          class="
          nav-link
          w-full
          block
          font-medium
          text-xs
          leading-tight
          uppercase
          border-x-0 border-t-0 border-b-2 border-transparent
          px-6
          py-3
          my-2
          hover:border-transparent hover:bg-gray-100
          focus:border-transparent
          active" 
          data-bs-toggle="pill" 
          data-bs-target="#tabs-homeFill" 
          role="tab"
          aria-controls="tabs-homeFill"
          aria-selected="true"
        >
          Stocktakes
        </a>
      </li>
      <li
        class="nav-item flex-auto text-center"
        role="presentation"
      >
        <a 
          id="tabs-profile-tabFill"
          href="#tabs-profileFill"
          class="
          nav-link
          w-full
          block
          font-medium
          text-xs
          leading-tight
          uppercase
          border-x-0 border-t-0 border-b-2 border-transparent
          px-6
          py-3
          my-2
          hover:border-transparent hover:bg-gray-100
          focus:border-transparent"
          data-bs-toggle="pill"
          data-bs-target="#tabs-profileFill"
          role="tab"
          aria-controls="tabs-profileFill"
          aria-selected="false"
        >
          Scans
        </a>
      </li>
    </ul>
    <div id="tabs-tabContentFill" class="tab-content">
      <div id="tabs-homeFill" class="tab-pane fade show active" role="tabpanel" aria-labelledby="tabs-home-tabFill">
        <div class="bg-white rounded-md shadow overflow-x-auto">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-3 pt-3 px-3">Date</th> 
              <th class="pb-3 pt-3 px-3">Coverage</th>
              <th class="pb-3 pt-3 px-3">Cycle</th>
              <th class="pb-3 pt-3 px-3">Tag</th>
              <th class="pb-3 pt-3 px-3">Location</th>
              <th class="pb-3 pt-3 px-3" colspan="3">Status</th>
            </tr>
            <tr v-for="stocktake in stocktakes.data" :key="stocktake.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" :href="`/stocktake-reference/${stocktake.id}/edit`" tabindex="-1">
                  {{ stocktake.date }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" :href="`/stocktake-reference/${stocktake.id}/edit`" tabindex="-1">
                  {{ stocktake.coverage }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" :href="`/stocktake-reference/${stocktake.id}/edit`" tabindex="-1">
                  {{ stocktake.cycle }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" :href="`/stocktake-reference/${stocktake.id}/edit`" tabindex="-1">
                  {{ stocktake.tag }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" :href="`/stocktake-reference/${stocktake.id}/edit`" tabindex="-1">
                  {{ stocktake.location }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" :href="`/stocktake-reference/${stocktake.id}/stocktakes`" tabindex="-1">
                  {{ stocktake.status === 1 ? 'On' : 'Off' }}
                </Link>
              </td>
              <td class="w-px border-t">
                <Link class="flex items-center px-3" :href="`/stocktake-reference/${stocktake.id}/edit`" tabindex="-1">
                  <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
                </Link>
              </td>
              <td v-show="stocktake.status == 1" class="w-px border-t">
                <svg
                  v-if="user.role === 'admin' || user.role === 'manager'"
                  @click="openDeleteModal(stocktake)"
                  xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 cursor-pointer" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" style="color: red;" title="Delete">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </td>
            </tr>
            <tr v-if="stocktakes.data.length === 0">
              <td class="px-3 py-3 border-t" colspan="7">No data found</td>
            </tr>
          </table>
        </div>
        <pagination class="mt-6" :links="stocktakes.links" />
      </div>
      <div id="tabs-profileFill" class="tab-pane fade" role="tabpanel" aria-labelledby="tabs-profile-tabFill">
        <div class="bg-white rounded-md shadow">
          <form @submit.prevent="downloadStocktake">
            <div class="flex flex-wrap -mb-2 -mr-6 pt-8 pl-8 pr-8 pb-8">
              <div class="w-1/3 lg:w-1/3 pb-2 pr-6">
                <multiselect
                  id="cycle"
                  v-model="selectedCycle"
                  placeholder="Cycles"
                  :options="cycles"
                  :close-on-select="true"
                  :searchable="true"
                  :error="form.errors.cycle_id"
                  :style="form.errors.cycle_id ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''"
                  @search-change="onSearchCycleChange"
                  @input="onSelectedCycle"
                />
                <div v-if="form.errors.cycle_id" class="form-error">{{ form.errors.cycle_id }}</div>
              </div>
              <div class="w-1/3 lg:w-1/3 pb-2 pr-6">
                <multiselect
                  id="Coverage"
                  v-model="selectedCoverage"
                  placeholder="Coverages"
                  :options="stocktake_coverages"
                  :close-on-select="true"
                  :searchable="true"
                  :error="form.errors.stocktake_coverage_id"
                  :style="form.errors.stocktake_coverage_id ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''"
                  @search-change="onSearchCoverageChange"
                  @input="onSelectedCoverage"
                />
                <div v-if="form.errors.stocktake_coverage_id" class="form-error">{{ form.errors.stocktake_coverage_id }}</div>
              </div>
              <div class="w-1/3 lg:w-1/3 pb-2 pr-6">
                <multiselect
                  id="tag"
                  v-model="selectedTag"
                  placeholder="Tags"
                  :options="tags"
                  :close-on-select="true"
                  :searchable="true"
                  :error="form.errors.tag"
                  :style="form.errors.tag ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''"
                  @search-change="onSearchTagChange"
                  @input="onSelectedTag"
                />
                <div v-if="form.errors.tag" class="form-error">{{ form.errors.tag }}</div>
              </div>
            </div>
            <div
              class="flex items-center justify-end w-full px-8 py-4 bg-gray-50 border-t border-gray-100"
            >
            <a
              :href="`/stocktakes/rawdata/download${url()}`"
              class="btn-orange px-3 py-2 text-xs cursor-pointer"
              download
              target="__blank"
            >
              <span>Download</span>
            </a>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!--modal content-->
  <div class="fixed z-10 inset-0 overflow-y-auto" v-if="isOpen">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen"></span>
      <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <form>
          <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              <p>
                You are about to remove the count tagged <strong>{{ tag_name }}</strong> for <strong>{{ location_name }}</strong>. Proceed?
              </p>
            </div>
          </div>
        <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
          <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
            <button type="button" @click="destroy(stocktake_ref_id)" class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-red-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-red-500 focus:outline-none focus:border-red-700 focus:shadow-outline-red sm:text-sm sm:leading-5">
              Delete
            </button>
          </span>
          <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
            <button @click="closeModal" type="button" class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5">
              Cancel
            </button>
          </span>
        </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'
import Pagination from '@/Shared/Pagination'
import Multiselect from '@vueform/multiselect'
import axios from 'axios'

export default {
  components: {
    Head,
    Icon,
    Link,
    SearchFilter,
    Pagination,
    Multiselect,
  },
  layout: Layout,
  remember: 'form',
  props: {
    filters: Object,
    stocktakes: Object,
    stocktake_coverages: Object,
    cycles: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
        cycle_id: null,
        stocktake_coverage_id: null,
        tag: null,
      }),
      search: {
        search: this.filters.search,
      },
      selectedCycle: null,
      selectedCoverage: null,
      selectedTag: null,
      tags: null,
      isOpen: false,
      tag_name: null,
      location_name: null,
      stocktake_ref_id: null,
    }
  },
  watch: {
    search: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/stocktake-references', pickBy(this.search), { preserveState: true })
      }, 150),
    },
  },
  computed: {
    user() {
      return this.$inertia.page.props.auth.user
    },
  },
  methods: {
    reset() {
      this.search = mapValues(this.search, () => null)
    },
    openDeleteModal(data) {
      this.tag_name = data.tag;
      this.stocktake_ref_id = data.id;
      this.location_name = data.location;
      this.isOpen = true;
    },
    closeModal() {
      this.tag_name = null;
      this.location_name = null
      this.stocktake_ref_id = null;
      this.isOpen = false;
    },
    destroy() {
      const data = {};
      data.id = this.stocktake_ref_id;
      data._method = 'DELETE';
      this.$inertia.post(`/stocktake-references/${data.id}/remove`, data)
      this.tag_name = null;
      this.location_name = null
      this.stocktake_ref_id = null;
      this.closeModal();
    },
    onSelectedTag(tag, id) {
      this.form.tag = tag
      this.selectedTag = tag
    },
    tag(cycle, coverage) {
      let data = {};
      data.cycle = cycle;
      data.coverage = coverage;
      this.tags = null;
      axios.post(`/stocktake-references/tags`, data).then(response => {
        this.tags = response.data
      })
    },
    onSearchTagChange: throttle(function () {
    }),
    onSelectedCycle(cycle, id) {
      this.form.cycle_id = cycle
      this.selectedCycle = cycle
      this.tag(this.selectedCycle, this.selectedCoverage);
    },
    onSearchCycleChange: throttle(function () {
    }, 200),
    onSelectedCoverage(coverage, id) {
      this.form.stocktake_coverage_id = coverage
      this.selectedCoverage = coverage
      this.tag(this.selectedCycle, this.selectedCoverage);
    },
    onSearchCoverageChange: throttle(function () {
      
    }),
    url() {
      let query = ''
      if (this.form.cycle_id) {
        query += `cycle_id=${this.form.cycle_id}`;
      }
      if (this.form.stocktake_coverage_id) {
        if (query) {
          query += '&';
        }
        query += `stocktake_coverage_id=${this.form.stocktake_coverage_id}`;
      }
      if (this.form.tag) {
        if (query) {
          query += '&';
        }
        query += `tag=${this.form.tag}`;
      }
      if (query) {
        query = `?${query}`;
      }
      return query
    },
  },
}
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style type="text/css">
  .multiselect-option.is-selected.is-pointed {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
  .multiselect-option.is-selected {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
</style>
